import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  title: {
    id: 'DQdHwN',
    defaultMessage: 'Return policy',
    description: 'Return Policy Card title in the returns settings of a store',
  },
  description: {
    id: 'I63wyI',
    defaultMessage: 'Define which items are eligible, time windows, and conditions.',
    description: 'Return Policy Card description in the returns settings of a store',
  },
});
